var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38298_87932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.02181 31.1123C0.923973 31.1123 -0.000804961 29.9229 0.964973 28.4696L18.7419 1.75406C19.7088 0.300729 21.2907 0.300729 22.2576 1.75406L40.0346 28.4705C41.0026 29.9229 40.0767 31.1123 37.9789 31.1123H3.02181Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7461 25.7358C17.747 25.1658 18.0376 24.6194 18.5541 24.2164C19.0706 23.8135 19.7708 23.5869 20.5011 23.5865C21.2312 23.5872 21.9311 23.8138 22.4473 24.2168C22.9636 24.6197 23.254 25.166 23.2549 25.7358C23.254 26.3057 22.9636 26.8521 22.4474 27.2551C21.9312 27.6582 21.2313 27.8851 20.5011 27.886C19.7707 27.8853 19.0705 27.6585 18.554 27.2554C18.0375 26.8523 17.747 26.3058 17.7461 25.7358ZM17.9579 9.47534C17.9579 8.31801 19.0524 7.60156 20.4999 7.60156C21.9133 7.60156 23.0431 8.34556 23.0431 9.47534V20.0869C23.0431 21.2167 21.9133 21.9607 20.4999 21.9607C19.0524 21.9607 17.9579 21.2433 17.9579 20.0869V9.47534Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38298_87932"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningVector);
export default __webpack_public_path__ + "static/media/WarningVector.faffdbda0d4af245bd2077cfd3a629fe.svg";
export { ForwardRef as ReactComponent };